import { createContext, useContext } from 'react'

/**
 * Lets a page (Mon île) ask the layout to reveal the mobile resource mini-banner
 * inside the sticky header once the page's own full ResourceBar has scrolled
 * away — so it sits flush under the header, exactly like every other page,
 * instead of a detached fixed overlay.
 *
 * The provider (AppLayout) holds the boolean state; consumers get the setter.
 */
export const StickyResourcesContext = createContext<(visible: boolean) => void>(() => {})

export function useSetStickyResources(): (visible: boolean) => void {
  return useContext(StickyResourcesContext)
}
